<template>
  <div id="HealthcareExperience">
     <v-expansion-panels  v-if="savedSchool.healthcare_experience_required  || savedSchool.healthcare_experience_community_service || savedSchool.cpr || savedSchool.basic_life_support || savedSchool.acls" focusable class="px-2 mt-3 ">
              <v-expansion-panel class="mt-2  "  >
                <v-expansion-panel-header  class="light-blue--text text--darken-4" >
                  <v-layout row align-center pb-0 >
                     <v-icon  v-if="completedAllHealthcareExp" color="green" >mdi-check-circle</v-icon>
                    <v-icon v-else color="red" >mdi-check-circle</v-icon>
                    <v-icon color="blue darken-3" class="ml-2">mdi-hospital-box</v-icon>
                    <span class="ml-2 blue--text text--darken-3 font-weight-medium">Experience Hours</span>
                  </v-layout>
                </v-expansion-panel-header>
                <v-expansion-panel-content eager class=" px-0 mx-0 pb-0 elevation-0 ">


                  <!-- Healthcare Hours Card -->
                  <v-card v-if="savedSchool.healthcare_experience_required && (savedSchool.healthcare_experience_required === false || savedSchool.healthcare_experience_recommended === false)"
                   class="innerCardCover elevation-0"
                   style="borderRadius:5px"
                   outlined
                   >

                    <v-layout v-if="savedSchool.healthcare_experience_required && !hasHealthCareExperience" class="red pb-2 justify-center">
                      <span v-if="savedSchool.healthcare_experience_required " class="white--text text-center mt-2">{{Math.abs(calculatePendingHealthcareHours)}} Experience Hours Pending</span>
                    </v-layout>
                    <v-layout v-else class="green pb-2 justify-center">
                      <span v-if="savedSchool.healthcare_experience_required " class="white--text text-center mt-2"> Experience Hours Completed</span>
                    </v-layout>


                     <v-layout v-if="totalAcceptedHealthCareHours / minHealthCareHours * 100 < '100'" mt-2 mx-2>
                       <v-progress-linear

                          color="red "
                          height="8"
                          :value="totalAcceptedHealthCareHours / minHealthCareHours * 100 "
                          rounded
                        ></v-progress-linear>
                     </v-layout>

                    <v-tabs
                      v-model="healthcareHoursTab"
                      background-color="transparent"
                      color="basil"
                      grow
                      class="mt-3 px-2"
                      hide-slider
                      >
                      <v-tab active-class="grey darken-2 white--text" style="marginLeft:0px;">

                        Required Hrs
                      </v-tab>

                      <v-tab active-class="primary white--text">
                      <v-icon small class="mr-2" >mdi-account-circle</v-icon>
                        My Hours
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="healthcareHoursTab">
                      <!-- Required Hours Tab Item -->
                      <v-tab-item class="pb-2">
                        <!-- Hours -->
                        <v-layout  v-if="savedSchool.healthcare_experience_required" mt-4 mb-2 column align-center justify-center>
                          <v-progress-circular  v-if="savedSchool.healthcare_experience_minimum_hours !== ''" :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium red--text" :class="{'green--text': hasHealthCareExperience, 'red--text' : !hasHealthCareExperience }" >{{savedSchool.healthcare_experience_minimum_hours}}</span></v-progress-circular>

                          <span v-if="savedSchool.healthcare_experience_minimum_hours === '' " class=" mt-2 mb-0  body-1 font-weight-regular grey--text">No Specified Hours</span>
                          <span  v-if="savedSchool.healthcare_experience_minimum_hours !== ''" class="mt-1   font-weight-light">Hours</span>
                        </v-layout>
                        <!-- Accepted Experience Card -->
                        <v-card
                          v-if="savedSchool.healthcare_experience_required"
                          style="borderRadius:5px" outlined class="mt-4 mx-2"
                          >
                          <v-layout justify-center class=" grey lighten-3 pb-2 ">
                            <span class="subtitle-1 mt-2 font-weight-regular">  Accepted Experience </span>
                            <v-icon @click="showAcceptedExpDialog = true" small class=" ml-2">mdi-information</v-icon>
                          </v-layout>

                          <v-card-text class="pt-2  ">
                            <v-layout  column class="pl-0 ml-0 ">
                              <v-layout v-if="savedSchool.healthcare_experience_direct_paid_patient_hours === false && savedSchool.healthcare_experience_direct_patient_hours === false && savedSchool.healthcare_experience_indirect_patient_hours === false && savedSchool.healthcare_experience_volunteer_hours === false" align-center justify-space-between >
                                <span class="">Any experience accepted</span>
                                <v-icon color="green" size="20px">mdi-check-circle</v-icon>
                              </v-layout>

                                <v-layout  v-if="savedSchool.healthcare_experience_direct_paid_patient_hours === true" mt-2 row   align-center justify-space-between mx-0>
                                  <span class=" font-weight-light black--text ">Paid Direct Patient Care</span>
                                  <v-icon color="blue darken-3" :color="hasValidHealthCareHours('healthcare_experience_direct_paid_patient_hours') ? 'green' : 'blue'" size="20px">mdi-check-circle</v-icon>
                                </v-layout>
                                <v-divider v-if="savedSchool.healthcare_experience_direct_paid_patient_hours === true" class="mt-2 mb-1 "></v-divider>

                                <v-layout v-if="savedSchool.healthcare_experience_direct_patient_hours === true " mt-2 row   align-center justify-space-between mx-0>
                                  <span class="font-weight-light black--text">Direct Patient Care </span>
                                  <v-icon color="blue darken-3" :color="hasValidHealthCareHours('healthcare_experience_direct_patient_hours') ? 'green' : 'blue'" size="20px">mdi-check-circle</v-icon>
                                </v-layout>
                                <v-divider v-if="savedSchool.healthcare_experience_direct_patient_hours === true "  class="mt-2 mb-1 "></v-divider>

                                <v-layout v-if="savedSchool.healthcare_experience_indirect_patient_hours === true" mt-2 row   align-center justify-space-between mx-0>
                                  <span class="font-weight-light black--text">Indirect Patient Care </span>
                                  <v-icon color="blue darken-3" :color="hasValidHealthCareHours('healthcare_experience_indirect_patient_hours') ? 'green' : 'blue'" size="20px">mdi-check-circle</v-icon>
                                </v-layout>
                                <v-divider v-if="savedSchool.healthcare_experience_indirect_patient_hours === true"  class="mt-2 mb-1 "></v-divider>

                                <v-layout v-if="savedSchool.healthcare_experience_volunteer_hours === true" mt-2 row   align-center justify-space-between mx-0>
                                  <span class="black--text font-weight-light">Volunteer</span>
                                  <v-icon color="blue darken-3" :color="hasValidHealthCareHours('healthcare_experience_volunteer_hours') ? 'green' : 'blue'" size="20px">mdi-check-circle</v-icon>
                                </v-layout>
                                <!-- MINIMUM VOLUNTEER HOURS NEED TO BE COMPLETED WITHIN -->
                                <v-layout v-if="savedSchool.healthcare_experience_minimum_volunteer_hours !== '' && savedSchool.healthcare_experience_minimum_volunteer_hours !== undefined " row   mt-1 >
                                  <span class="ml-3  grey--text ">  Minimum Volunteer Hours: <span class="font-weight-bold red--text">{{savedSchool.healthcare_experience_minimum_volunteer_hours}} hrs</span> </span>
                                </v-layout>
                                <v-divider v-if="savedSchool.healthcare_experience_volunteer_hours === true" class="mt-2 mb-1 "></v-divider>



                          </v-layout>

                          </v-card-text>
                        </v-card>
                        <!-- ACCEPTED EXPERIENCE DIALOG -->
                        <v-dialog
                            v-model="showAcceptedExpDialog"
                            scrollable
                            max-width="400"
                            persistent
                            style="zIndex:2000"
                          >

                          <v-card style="borderRadius:10px">
                              <v-card-title class="title grey lighten-2 text-xs-center mb-2">
                                Healthcare Experience Hours
                              </v-card-title>
                              <v-card-text class="text-xs-justify" >
                                Each program's definitions and requirements of patient/healthcare experience vary. If you have any questions about your experiences fulfilling an individual program's patient/healthcare experience requirements, contact that program directly.
                              </v-card-text>

                              <v-card-text class="pt-0" >
                                <v-subheader class="pl-0 black--text" style="height:30px">Paid Direct Patient Care Experience:</v-subheader>
                                Paid experiences in which you are directly responsible for a patient's care.
                              </v-card-text>

                              <v-card-text class="pt-0" >
                                <v-subheader class="pl-0 black--text" style="height:30px">Direct Patient Care Experience:</v-subheader>
                                  Non-paid (volunteer) experiences in which you are directly responsible for a patient's care.

                              </v-card-text>

                              <v-card-text class="pt-0" >
                                <v-subheader class="pl-0 black--text" style="height:30px">Indirect Patient Care Experience:</v-subheader>
                                  Both paid and unpaid (volunteer) experiences in a health or health-related field where you are not directly responsible for a patient's care, but may still have patient interaction.

                              </v-card-text>
                              <v-card-actions>
                                  <v-btn @click="showAcceptedExpDialog = false" block color="red" class="elevation-0" dark >Close</v-btn>
                                </v-card-actions>

                          </v-card>

                        </v-dialog>

                        <!-- Healthcare Conditions Card -->
                        <v-card
                          v-if="savedSchool.healthcare_experience_minimum_year !== '' && savedSchool.healthcare_experience_minimum_year !== undefined "
                          style="borderRadius:5px" outlined class="mt-4 mx-2"
                          >
                          <v-layout justify-center class=" grey lighten-3 pb-2 ">
                            <span class="subtitle-1 mt-2 font-weight-regular"> Conditions </span>
                          </v-layout>

                          <v-card-text class="pt-2  ">
                            <v-layout  column class="pl-0 ml-0 ">


                                <v-layout  mt-2 row   align-center justify-space-between mx-0>
                                  <span class=" font-weight-light black--text ">Healthcare Experience needs to be completed within <span class="font-weight-medium blue--text text--darken-3">{{savedSchool.healthcare_experience_minimum_year}} years</span></span>
                                </v-layout>




                          </v-layout>

                          </v-card-text>
                        </v-card>

                      </v-tab-item>

                      <!-- My Hours Tab Item-->
                      <v-tab-item class="pb-2">
                        <!-- Hours -->
                        <v-layout mt-4 mb-2 column align-center justify-center>
                          <v-progress-circular :width="3" size="80" :value=100  color="grey"> <span class="percentageValue headline   blue--text text--darken-3 font-weight-medium ">{{userTotalHealthcareHours | round}}</span></v-progress-circular>
                          <span class="mt-1 font-weight-light">My Total Hours</span>
                        </v-layout>
                        <!-- My Hours Break Down -->
                        <v-card style="borderRadius:5px" outlined class="mt-4 mx-2">
                          <v-layout align-center justify-center class=" primary pb-2 ">
                            <v-icon small class="mr-2 mt-2" color="white">mdi-account-circle</v-icon>
                            <span class="subtitle-1 mt-2 font-weight-regular white--text">  My Healthcare Hours </span>
                          </v-layout>

                          <v-card-text class="pt-2  ">
                            <v-layout  column class="pl-0 ml-0 ">


                                <v-layout   mt-2 row   align-center justify-space-between mx-0>
                                  <span class=" font-weight-light black--text ">Paid Direct Patient Care</span>
                                  <span class="body-1">{{totalDirectPaidHours}} hrs</span>
                                </v-layout>
                                <v-divider  class="mt-2 mb-1 "></v-divider>

                                <v-layout  mt-2 row   align-center justify-space-between mx-0>
                                  <span class="font-weight-light black--text">Direct Patient Care </span>
                                  <span class="body-1">{{totalDirectHours}} hrs</span>
                                </v-layout>
                                <v-divider  class="mt-2 mb-1 "></v-divider>

                                <v-layout  mt-2 row   align-center justify-space-between mx-0>
                                  <span class="font-weight-light black--text">Indirect Patient Care </span>
                                  <span class="body-1">{{totalIndirectHours}} hrs</span>
                                </v-layout>
                                <v-divider  class="mt-2 mb-1 "></v-divider>

                                <v-layout  mt-2 row   align-center justify-space-between mx-0>
                                  <span class="black--text font-weight-light">Volunteer</span>
                                  <span class="body-1">{{totalVolunteerHours}} hrs</span>
                                </v-layout>

                                <v-divider  class="mt-2 mb-1 "></v-divider>
                          </v-layout>

                          </v-card-text>
                        </v-card>


                      </v-tab-item>
                    </v-tabs-items>


                  </v-card>

                  <!-- COMMUNITY SERVICE CARD -->
                  <v-card v-if="savedSchool.healthcare_experience_community_service === true"
                    class=" pb-0 innerCardCover elevation-0"
                    style="borderRadius:5px"
                    outlined
                    >
                    <v-layout v-if="hasCommunityServiceHours" class="green pb-2 justify-center">
                          <span  class="white--text text-center mt-2">Community Service Hours Completed</span>
                      </v-layout>
                      <v-layout v-else class="red pb-2 justify-center">
                          <span  class="white--text text-center mt-2"><span v-if="minCommunityServiceHours !== 0">{{minCommunityServiceHours - totalCommunityServiceHours}}</span> Community Service Hours Pending</span>
                      </v-layout>

                      <v-layout v-if="totalCommunityServiceHours / minCommunityServiceHours * 100 < '100'" mt-2 mx-2>
                       <v-progress-linear

                          color="red "
                          height="8"
                          :value="totalCommunityServiceHours / minCommunityServiceHours * 100 "
                          rounded
                        ></v-progress-linear>
                     </v-layout>

                      <v-tabs
                      v-model="communityServiceHoursTab"
                      background-color="transparent"
                      color="basil"
                      grow
                      class="mt-3 px-2"
                      >
                      <v-tab active-class="grey darken-2 white--text" style="marginLeft:0px;">

                        Required Hrs
                      </v-tab>

                      <v-tab active-class="primary white--text">
                      <v-icon small class="mr-2" >mdi-account-circle</v-icon>
                        My Hours
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="communityServiceHoursTab">
                      <!-- Required Hours Tab Item -->
                      <v-tab-item class="pb-2">
                        <!-- Hours -->
                        <v-layout v-if="savedSchool.healthcare_experience_community_service_hours !== '' && savedSchool.healthcare_experience_community_service_hours !== undefined" mt-4  column align-center justify-center>
                          <v-progress-circular :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline  font-weight-medium " :class="{'green--text' : hasCommunityServiceHours, 'red--text' : !hasCommunityServiceHours}">{{savedSchool.healthcare_experience_community_service_hours}}</span></v-progress-circular>
                          <span class=" mt-1 black--text font-weight-light">Hours</span>
                        </v-layout>
                        <v-layout v-else mt-1 row  align-center justify-center>
                          <span class="grey--text">No Specified Hours</span>
                        </v-layout>

                      </v-tab-item>

                      <!-- My Hours Tab Item-->
                      <v-tab-item class="pb-2">
                        <!-- Hours -->
                        <v-layout mt-4  column align-center justify-center>
                          <v-progress-circular :width="3" size="80" :value=100  color="grey"> <span class="percentageValue headline   blue--text text--darken-3 font-weight-medium ">{{totalCommunityServiceHours | round }}</span></v-progress-circular>
                          <span class="mt-1 font-weight-light">My Total Hours</span>
                        </v-layout>



                      </v-tab-item>
                    </v-tabs-items>

                  </v-card>

                  <!-- CERTIFICATIONS CARD -->
                  <v-card v-if="savedSchool.cpr === true || savedSchool.basic_life_support === true || savedSchool.acls === true"
                    class="mt-4  pb-2 innerCardCover elevation-0"
                    style="borderRadius:5px"
                    outlined
                    >

                    <v-layout v-if="totalRequiredCertifications.length - completedCertifications > 0"  class="red pb-2 justify-center">
                      <span  class="white--text text-center mt-2" >{{totalRequiredCertifications.length - completedCertifications}} Certification Pending</span>
                    </v-layout>



                     <v-layout v-else class="green pb-2 justify-center">
                      <span  class="white--text text-center mt-2" > Certifications Completed</span>
                    </v-layout>




                    <v-card-text class="pt-2">

                      <!-- CPR -->
                      <v-layout  v-if="savedSchool.cpr === true" mt-2 row   align-center justify-space-between mx-0>
                        <span class=" font-weight-light black--text ">CPR</span>
                        <v-icon v-if="hasCertification('CPR')" color="green" class="" size="20px">mdi-check-circle</v-icon>
                        <v-icon v-else color="red" class="" size="20px">mdi-check-circle</v-icon>
                      </v-layout>
                      <v-divider v-if="savedSchool.cpr === true"  class="mt-2 mb-1 "></v-divider>

                      <!-- BLS -->
                      <v-layout  v-if="savedSchool.basic_life_support === true"  mt-2 row   align-center justify-space-between mx-0>
                        <span class=" font-weight-light black--text ">BLS</span>
                          <v-icon v-if="hasCertification('BLS')" color="green" class="" size="20px">mdi-check-circle</v-icon>
                          <v-icon v-else  color="red" class="" size="20px">mdi-check-circle</v-icon>
                      </v-layout>
                      <v-divider v-if="savedSchool.basic_life_support === true"  class="mt-2 mb-1 "></v-divider>

                      <!-- ACLS -->
                      <v-layout v-if="savedSchool.acls === true"  mt-2 row   align-center justify-space-between mx-0>
                        <span class=" font-weight-light black--text ">ACLS</span>
                        <v-icon v-if="hasCertification('ACLS')" color="green" class="" size="20px">mdi-check-circle</v-icon>
                        <v-icon v-else color="red" class="" size="20px">mdi-check-circle</v-icon>
                      </v-layout>
                      <v-divider v-if="savedSchool.acls === true" class="mt-2 mb-1 "></v-divider>

                    </v-card-text>
                  </v-card>

                  <!-- Healthcare Notes -->
                  <v-card v-if="savedSchool.healthcareNotes" outlined class=" mt-4 mb-4">
                    <v-layout align-center justify-center class=" pb-1" >
                      <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
                      <span class="font-weight-light align-center">Additional Notes </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{savedSchool.healthcareNotes}}</span>
                    </v-card-text>
                  </v-card>




                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
  </div>
</template>

<script>
  import userMixins from '@/mixins/usersmixin'
  import checkHealthcareExperienceMixin from '@/mixins/requirementchecks/checkhealthcareexperiencemixin'
  export default {
    mixins: [userMixins,checkHealthcareExperienceMixin],
    props: ['savedSchool'],
    data() {
      return {
        gpaTab: null,
        healthcareHoursTab: null,
        communityServiceHoursTab: null,
        showCaspaCalulationMethod: false,
        showAcceptedExpDialog: false,
      }
    },
    computed : {
      userTotalHealthcareHours () {
        return this.totalVolunteerHours + this.totalIndirectHours + this.totalDirectHours + this.totalDirectPaidHours
      }
    }

  }
</script>

<style scoped>
.v-expansion-panel::before {
   box-shadow: 0 10px 20px -10px rgba(0,0,0,.19)  !important;
}

.innerCardCover {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  border-radius: 5px;
  padding: 0;
  margin-top: 12px;
}



</style>



// WEBPACK FOOTER //
// src/components/Dashboard/SavedSchools/RequirementTracker/HealthcareExperience.vue